module.exports = __webpack_public_path__ + "img/qa.39448bf8.svg";